import React from 'react'

// internal use only
const createContext = (_name) => React.createContext()

export default createContext('dynamicReducerProviderContext')
